import { moduleApi } from '@/api/super-admin/module.api';

export const moduleService = {
  getAvailableModules: async () => {
    const data = await moduleApi.getAvailableModules();
    return { data };
  },

  getAssignedModules: async (schoolId) => {
    const data = await moduleApi.getAssignedModules(schoolId);
    return { data };
  },

  assignModulesToSchool: async (schoolId, moduleIds) => {
    const data = await moduleApi.assignModules(schoolId, moduleIds);
    return { data };
  },
};
